
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
Msg,
Divider,
XButton
},
data () {
return {
errmsg: '',
errtitle: '',
icon: '',
buttons: [{
type: 'primary',
text: '返回首页',
link: '/wx/home'
}]
}
},
created () {
this.errmsg = sessionStorage.getItem('errmsg')
this.icon = 'warn'
this.errtitle = sessionStorage.getItem('errmsg')
}
}



// WEBPACK FOOTER //
// ./src/components/error.vue